import gql from 'graphql-tag';
const FILL_BLANK_SENTENCES_ACTIVITY_FRAGMENT = gql `
  fragment FillBlankSentencesActivityFragment on FillBlankSentencesActivity {
    rounds {
      steps {
        id
        optionalImage {
          image {
            description
            id
            src
          }
        }
        answer
      }
    }
  }
`;
export default FILL_BLANK_SENTENCES_ACTIVITY_FRAGMENT;
